import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IAngularMyDpOptions, IMyDateModel } from 'angular-mydatepicker';
import { DatasearchService } from 'src/app/_services/datasearch.service';
import { ToastserviceService } from 'src/app/_services/toastservice.service';
import * as moment from 'moment';

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import htmlToPdfmake from 'html-to-pdfmake';
import { TRISTATECHECKBOX_VALUE_ACCESSOR } from 'primeng/tristatecheckbox';

@Component({
  selector: 'app-invoice-generation',
  templateUrl: './invoice-generation.component.html',
  styleUrls: ['./invoice-generation.component.scss'],
})
export class InvoiceGenerationComponent implements OnInit {
  @ViewChild('pdfTable') pdfTable: ElementRef;

  myDpOptions: IAngularMyDpOptions = {
    dateRange: false,
    dateFormat: 'dd-mmm-yyyy',
    showFooterToday: true,
    todayTxt: 'Today',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    inline: false,
  };
  showInvoiceDtls: boolean = false;
  invoiceMode: string = 'ADD';
  userid: number = 0;
  beforeEditData_invoceDtls:any;
  currentMenuDtls:any;

  constructor(
    private formBuilder: FormBuilder,
    private toastService: ToastserviceService,
    private datasearchService: DatasearchService
  ) {}

  ngOnInit(): void {

    let currentUserdtls=JSON.parse(localStorage.getItem('currentUser'));
    this.userid = currentUserdtls.userid;


    this.currentMenuDtls = JSON.parse(
      sessionStorage.getItem('currentMenuDtls')
    );

    this.currentMenuDtls.roleacc_is_view=this.currentMenuDtls.roleacc_is_view==1;
    this.currentMenuDtls.roleacc_is_edit=this.currentMenuDtls.roleacc_is_edit==1;
    this.currentMenuDtls.roleacc_is_delete=this.currentMenuDtls.roleacc_is_delete==1;

    this.loadInvoiceDtls();

    this.createForm();
  }

  //#region Grid Invoice Detail(s)
  invoice_pagenumber: number = 1;
  invoice_rowscount: number = 10;
  invoice_loading_table: boolean = false;
  invoice_totalRecords: number = 0;
  invoice_current_datasource: any = [];
  loadInvoiceDtls(){
    this.invoice_loading_table = true;
    let postdata = {
      mode: 'GET_INVOICE_DATA',
      search_keyword: this.searchKeyword,
      pagenumber: this.invoice_pagenumber,
      rowscount: this.invoice_rowscount
    };
    this.datasearchService.manageInvoice(postdata,true).subscribe(
      (res) => {
        console.log(res);
        this.invoice_totalRecords = Number(res[0][0].TotalRecords);
        this.invoice_current_datasource = res[1];
        this.invoice_loading_table = false;
        this.isNoMorerecords=this.invoice_totalRecords<this.invoice_rowscount;
      },
      (error) => {
        console.log(error);
        this.invoice_loading_table = false;
      }
    );
  }

  searchKeyword:string="";
  onSearch(){
    this.invoice_pagenumber=1;
    this.loadInvoiceDtls();
  }

  isNoMorerecords: boolean = false;
  onScroll(event: any) {
    
    if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
      console.log("End");
      if (this.isNoMorerecords == false) {

        this.invoice_loading_table = true;
        let currentcount = this.invoice_current_datasource.length;
        if (currentcount >= this.invoice_rowscount) {
          this.invoice_pagenumber =
            Math.ceil(currentcount / this.invoice_rowscount) + 1;
          console.log(event);
          //if (currentcount - 1 == event.endIndex && event.endIndex > 0) {
            let postdata = {
              mode: 'GET_INVOICE_DATA',
              search_keyword: this.searchKeyword,
              pagenumber: this.invoice_pagenumber,
              rowscount: this.invoice_rowscount
            };
            this.datasearchService.manageInvoice(postdata,true).subscribe(
              (res) => {
                console.log(res);
                this.isNoMorerecords = res[1].length == 0;
                this.invoice_current_datasource =
                this.invoice_current_datasource.concat(res[1]);
                this.invoice_loading_table = false;
  
              },
              (error) => {
                console.log(error);
                this.invoice_loading_table = false;
              }
            );
          //}
        }

      }
    }
  }

  addInvoice(){
    this.showInvoiceDtls=true;
    this.invoiceMode='ADD';
    this.invoiceForm.reset();
    this.invoiceCaseData=[];

  }

  actionInvoice(invoiceItem,mode){
    this.invoiceMode="EDIT";
    
    this.invoiceForm.controls.invoice_id.setValue(invoiceItem.invoice_id);
    this.invoiceForm.controls.invoice_name.setValue(invoiceItem.invoice_name);
    this.invoiceForm.controls.invoice_number.setValue(invoiceItem.invoice_number);
    //Set client
    let invoice_client_data=JSON.parse(invoiceItem.invoice_client_data);
    this.invoiceForm.controls.invoice_client_id.setValue(invoice_client_data[0]);
    // Set invoice date
    let strinvDate=invoiceItem.invoice_date;
    let invoiceDate=moment(strinvDate,"DD-MMM-YYYY");
    let model_invoiceDate: IMyDateModel = {isRange: false, singleDate: {date: { 
      year: invoiceDate.year(), 
      month: invoiceDate.month()+1, 
      day: invoiceDate.date() 
    },formatted:strinvDate}, dateRange: null};
    this.invoiceForm.controls.invoice_date.setValue(model_invoiceDate);
    //Get case data
    this.invoiceCaseData=JSON.parse(invoiceItem.invoice_casedata);
    this.invoiceForm.controls.invoice_casedata.setValue(this.invoiceCaseData);

    if(mode=='edit'){
      this.showInvoiceDtls=true;
      this.beforeEditData_invoceDtls=JSON.parse(JSON.stringify(this.invoiceForm.value));
    }
    else if(mode=='download' || mode=='preview'){
      this.downloadAsPDF(mode);
    }
    else if(mode=='delete'){
      this.toastService.showConfirm(`Do you want to delete this invoice?`,`Invoice Name : ${invoiceItem.invoice_name}`,(confiremed)=>{
        if(confiremed){
          this.deleteInvoice(invoiceItem);
        }
      });
    }
    
   
    
  }

  deleteInvoice(invoiceItem){
   let postdata={
    mode:"DELETE_INVOICE",
    invoice_id:invoiceItem.invoice_id,
    userid:this.userid
   }

   this.datasearchService.manageInvoice(postdata).subscribe(res=>{
    this.toastService.showSuccess("Success!",`Invoice - ${ invoiceItem.invoice_name} deleted.`);
    this.loadInvoiceDtls();
   });
  }
  
  //#endregion

  //#region INVOICE FORM
  invoiceForm: FormGroup;
  invoiceCaseForm: FormGroup;
  invoiceCaseData: any[] = [];
  clientAutocompleteDtls: any[];

  createForm() {
    this.invoiceForm = this.formBuilder.group({
      invoice_id: [0],
      invoice_name: ['', Validators.required],
      invoice_client_id: [null, Validators.required],
      invoice_number: [null, Validators.required],
      invoice_date: [null, Validators.required],
      invoice_casedata: [null, Validators.required],
    });

    this.invoiceCaseForm = this.formBuilder.group({
      case_desc: ['', Validators.required],
      databse_access: ['', Validators.required],
      users: ['', Validators.required],
      term: ['', Validators.required],
      offered_price: [
        null,
        [
          Validators.required,
          Validators.pattern('^[0-9]*$'),
          Validators.maxLength(10),
        ],
      ],
      amount: [
        null,
        [
          Validators.required,
          Validators.pattern('^[0-9]*$'),
          Validators.maxLength(10),
        ],
      ],
    });
  }

  searchClient(event) {
    let postdata = {
      searchword: event.query,
      tablename: 'TBL_MSTR_CLIENT',
      columnname: 'clnt_company_name,id,clnt_company_logo',
      pagenumber: 1,
      rowscount: 100,
    };
    this.datasearchService
      .GetDropDownValues(postdata, true)
      .subscribe((res) => {
        this.clientAutocompleteDtls = res;
    });
  }

  //Adding Case Data
  addCaseData() {
    if (this.invoiceCaseForm.valid) {
      let invoicetempCaseData: any = {
        case_desc: this.invoiceCaseForm.controls.case_desc.value,
        databse_access: this.invoiceCaseForm.controls.databse_access.value,
        users: this.invoiceCaseForm.controls.users.value,
        term: this.invoiceCaseForm.controls.term.value,
        offered_price: this.invoiceCaseForm.controls.offered_price.value,
        amount: this.invoiceCaseForm.controls.amount.value,
      };

      this.invoiceCaseData.push(invoicetempCaseData);

      //set it into main form
      this.invoiceForm.controls.invoice_casedata.setValue(this.invoiceCaseData);

    
      
    } else {
      this.toastService.showWarning(
        'Enter the Case Details',
        'please file the Cases / Description,Database Access,Users,Term, Offered price and Amount.'
      );
    }
  }

  removeCaseData(objCase) {
    this.toastService.showConfirm(
      'Are you sure want to delete?',
      'Selected Case Data',
      (confirmed) => {
        if (confirmed) {
          let indexdelete = this.invoiceCaseData.findIndex((ele) => {
            return ele.column_id == objCase.column_id;
          });

          if (indexdelete === -1) {
            return false;
          }
          this.invoiceCaseData.splice(indexdelete, 1);
        }
      }
    );
  }

  saveInvoiceForm() {
    console.log(this.invoiceForm.value);

    let formdata=this.invoiceForm.value;

    if(JSON.stringify(formdata)==JSON.stringify(this.beforeEditData_invoceDtls)){

      this.toastService.showWarning("No Changes Made!","Please modify the invoice detail to continue.")
      return;
    }

    let postdata={
      mode:"SAVE_INVOICE",
      invoice_id:formdata.invoice_id,
      invoice_name:formdata.invoice_name,
      invoice_client_id:formdata.invoice_client_id.id,
      invoice_number: formdata.invoice_number,
      invoice_date:formdata.invoice_date.singleDate.formatted,
      invoice_casedata:formdata.invoice_casedata,
      userid:this.userid
    };

    this.datasearchService.manageInvoice(postdata).subscribe(res=>{
      if(formdata.invoice_id==0){
        this.toastService.showSuccess(`Invoice Added!`,`Invoice (${formdata.invoice_name}) template creation completed for ${formdata.invoice_client_id.clnt_company_name}.`);

      }
      else{
        this.toastService.showSuccess(`Invoice Updated!`,`Invoice (${formdata.invoice_name}) template updated for ${formdata.invoice_client_id.clnt_company_name}.`);

      }
      this.invoiceCaseForm.reset();
      this.showInvoiceDtls=false;
      this.loadInvoiceDtls();
    });
  }

  public downloadAsPDF(mode) {

    //var html = htmlToPdfmake(pdfTable.innerHTML);

    let invoiceCaseDataArray = [
      [
        { text: 'S.NO', bold: true },
        { text: 'Cases / Description', bold: true },
        { text: 'Database Access', bold: true },
        { text: 'Users', bold: true },
        { text: 'Term', bold: true },
        { text: 'Offered Price', bold: true },
        { text: 'Amount', bold: true },
      ],
    ];
    this.invoiceCaseData.forEach((item, index) => {
      invoiceCaseDataArray.push([
        index + 1,
        item.case_desc,
        item.databse_access,
        item.users,
        item.term,
        parseInt(item.offered_price).toLocaleString('en-IN', {
          maximumFractionDigits: 2,
          style: 'currency',
          currency: 'INR'
      }),
      parseInt(item.amount).toLocaleString('en-IN', {
          maximumFractionDigits: 2,
          style: 'currency',
          currency: 'INR'
      }),
      ]);
    });

    var dd = {
      content: [
        {
          columns: [
            {
              stack: [
                {
                  text: 'ChemRobotics Private Limited',
                  style: ['header', 'bigfont'],
                },
                {
                  text: 'CIN NO. U74999MP2018PTC046833',
                  style: 'subheader',
                },
                {
                  text: 'GST REG NO. 23AAHCC8027F1ZW',
                  style: 'subheader',
                },
                {
                  text: 'PAN NO. AAHCC8027F',
                  style: 'subheader',
                },
              ],
            },
            {
              image:
                'data:image/png;base64,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',
              width: 100,
              height: 60,
            },
          ],
        },
        {
          canvas: [
            { type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 },
          ],
          margin: [0, 10, 0, 10],
        },
        {
          text: `Offer Pricing for ${this.invoiceForm.controls.invoice_client_id.value?.clnt_company_name}.`,
          style: 'bigfont',
          margin: [0, 0, 0, 10],
        },
        {
          columns: [
            {
              stack: [
                {
                  text: 'To,',
                  style: ['small'],
                  margin: [0, 0, 0, 5],
                },
                {
                  text: `M/s. ${this.invoiceForm.controls.invoice_client_id.value?.clnt_company_name}.`,
                  style: ['small'],
                  margin: [0, 0, 0, 5],
                },
              ],
            },
            {
              stack: [
                {
                  text: `DATE : ${this.invoiceForm.controls.invoice_date.value?.singleDate.formatted}`,
                  style: ['small'],
                  margin: [0, 0, 0, 5],
                  alignment: 'right',
                  bold: true,
                },
                {
                  text: `INVOICE NO: ${this.invoiceForm.controls.invoice_number.value}`,
                  style: ['small'],
                  margin: [0, 0, 0, 5],
                  alignment: 'right',
                  bold: true,
                },
              ],
            },
          ],
        },
        {
          margin: [0, 10, 0, 0],
          table: {
            body: [
              [
                {
                  margin: [7, 7],
                  stack: [
                    {
                      margin: [0, 0, 0, 6],
                      color: '#5643fa',
                      bold: true,
                      style: ['medium'],
                      text: 'Product Offer Pricing: All Database Access Pack - Indian Platinum Pack (IPP)*',
                    },
                    {
                      style: ['small'],
                      text: [
                        '* IPP is a special discounting pricing pack, applicable for Indian origin companies only, wherein user will be subscribing all ten ChemRobotics databases including AgroPat Lite, AgroPat Ultimate, IPD, Global MRL, Global Agro Product Directory, JARVIS AgroPat, Technical Routes, Technical Suppliers, AgroPharm XIM DB & PharmVetPat Ultimate - ',
                        {
                          style: ['small'],
                          bold: true,
                          text: 'Product Offer Pricing: All Database Access Pack - Indian Platinum Pack (IPP)*',
                        },
                      ],
                    },
                  ],
                },
              ],
            ],
          },
        },
        {
          margin: [0, 10, 0, 7],
          color: '#5643fa',
          bold: true,
          style: ['medium'],
          text: 'All ChemRobotics Databases Access - Indian Platinum Pack (IPP)',
        },
        {
          style: 'small',
          table: {
            body: invoiceCaseDataArray,
          },
        },
        {
          margin: [0, 12, 0, 7],
          bold: true,
          style: ['medium'],
          text: 'Terms and Condition: -',
        },
        {
          margin: [20, 0, 0, 3],
          style: ['medium'],
          text: '1.Tax                           - 18 % GST Extra.',
        },
        {
          margin: [20, 0, 0, 3],
          style: ['medium'],
          text: '2.Validity of User ID  - 12 months.',
        },
        {
          margin: [20, 0, 0, 3],
          style: ['medium'],
          text: '3.Payment Cycle        - Advance Annual.',
        },
        {
          margin: [20, 0, 0, 3],
          style: ['medium'],
          text: '4.Duly signed agreed Non-disclosure Agreement (NDA)',
        },
        {
          margin: [0, 12, 0, 7],
          style: ['medium'],
          text: 'Thanking you and assuring our best services at all times.',
        },
        { margin: [0, 12, 0, 7], style: ['medium'], text: 'Yours truly,' },
        {
          margin: [0, 0, 0, 4],
          style: ['medium'],
          text: 'For, ChemRobotics Pvt Ltd.',
        },
        {
          margin: [0, 0, 0, 4],
          style: ['medium'],
          text: 'For, Authorized Signatory',
        },
      ],
      footer: {
        stack: [
          {
            canvas: [
              { type: 'line', x1: 0, y1: 0, x2: 540, y2: 0, lineWidth: 2 },
            ],
            margin: [20, 0, 20, 5],
          },
          {
            style: ['small'],
            bold: true,
            text: [
              {
                text: 'Regd. office. Address: House No. 9, Ward No. 23, Jawahar Ganj, Dabra, District Gwalior, Madhya Pradesh 475110 | Cell No.6266117944 | Website: ',
              },
              {
                text: 'www.chemrobotics.com ',
                link: 'https://chemrobotics.com',
                color: '#596062',
              },
              { text: 'Email: ' },
              {
                text: 'director@chemrobotics.com',
                link: 'mailto: director@chemrobotics.com',
                color: '#596062',
              },
            ],
            margin: [20, 0, 20, 0],
          },
        ],
      },
      styles: {
        bigfont: {
          fontSize: 18,
        },
        header: {
          bold: true,
          color: '#1769aa',
        },
        subheader: {
          fontSize: 11,
          bold: true,
          color: '#1769aa',
        },
        quote: {
          italics: true,
        },
        small: {
          fontSize: 10,
        },
        medium: {
          fontSize: 11,
        },
      },
      
    };

    //const documentDefinition = { content: html };
   
    if(mode=='preview'){
      pdfMake.createPdf(dd).open();
    }
    else{
      pdfMake.createPdf(dd).download(`Invoice_${this.invoiceForm.controls.invoice_client_id.value?.clnt_company_name}`);
    }
    
  }

  //#endregion
}
